import { AirbrakeNotifier } from 'Components/Airbrake';

export const notifyDatadogAndAirbrake = async (
  errorMessage: string,
  contextComponent: string,
  data: any
) => {
  (window as any).DD_RUM.addAction('html_received', {
    body: data,
  });

  return AirbrakeNotifier.notify({
    error: errorMessage,
    context: {
      component: contextComponent,
      data,
    },
  });
};
